import { render, staticRenderFns } from "./CreateGlobalAlert.vue?vue&type=template&id=1d1e7ceb&"
import script from "./CreateGlobalAlert.vue?vue&type=script&lang=js&"
export * from "./CreateGlobalAlert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports